export default "__VITE_ASSET__BnIiBVnr__"